import { convertMoneytoFloat } from '../functions/helpers';


export default (value, args) => {
  const decimals = convertMoneytoFloat(value);
  return decimals <= parseFloat(args[0]);
};



// WEBPACK FOOTER //
// ./src/common/validations/money-max.js